import "./NotFound.css";

const NotFound = () => {
    return (
        <>
            <div className="not_found_page">
                <h1>403</h1>
                <h2 className="coming_soon">PŘÍSTUP ODEPŘEN</h2>
            </div>
        </>
    );
};

export default NotFound;
